import Gator from 'gator';
import Headroom from 'headroom.js';

let header;

_gg.onReady.PageHeader = () => {
    header = document.querySelector('.page-header');

    if (header && header.classList.contains('headroom')) {
        let headr = new Headroom(header, {
            // vertical offset in px before element is first unpinned
            offset: 450,
            // scroll tolerance in px before state changes
            tolerance: {
                up: 5,
                down: 0
            }
        });
        headr.init();
    }
};

Gator(_gg.html).on('click', '.nav-element.-level1.-hassub > a', event => {
    event.stopPropagation();
});

Gator(_gg.html).on('click', '.nav-element.-level1.-hassub', function() {
    this.classList.toggle('-listopen');
});

function initMobileNavButton() {
    const buttonTemplate = document.querySelector('.js-nav-button-template');
    const navList = document.querySelector('.nav-list.-entry1');
    const navElement = document.createElement('li');

    if (!buttonTemplate || !navList) {
        return;
    }

    const clone = buttonTemplate.content.cloneNode(true);    
    if (clone.querySelector('.nav-button')) {
        clone.querySelector('.nav-button').classList.add('nav-button--mobile')
    }
        
    navElement.className = 'nav-element -normal -level1 -nosub nav-element--button';
    navElement.appendChild(clone);
    navList.appendChild(navElement);
}

initMobileNavButton();
